import { Modal } from "antd";
import React from "react";
import { svg } from "../../../../../Assets/svg";
import { momentFullTime } from "../../../../../helpers/utils";

const PlaningNotSaveWarning: React.FC<{
  visible: boolean;
  setIsModalVisible: any;
  isWarrningDate: boolean;
}> = ({ visible, setIsModalVisible, isWarrningDate }) => {
  const onClose = () => {
    setIsModalVisible(false);
  };
  return (
    <Modal
      title={
         <div className="text-center fs-4 fw-bolder lh-m">
          {isWarrningDate
            ? "Another Form Is Already in Edit Mode"
            : "Add Production Planning Dates"}
        </div>
      }
      visible={visible}
      onCancel={onClose}
      width={"32.813rem"}
      closeIcon={svg.closeIcon}
      centered
      footer={
        <div className="d-flex justify-content-center gap-4">
          <button
            type="button"
            className="btn btn-lg btn-outline-secondary min-w-130"
            onClick={onClose}
          >
            CLOSE
          </button>
        </div>
      }
      className="commonModalClass"
    >
      <div className="modal-body page-form">
        <p className="fs-6 mt-3 text-center text-4a4a4a">
          {isWarrningDate
            ? "You are currently editing another form. Please save or discard those changes before editing a new form."
            : "Production planning dates are required to schedule and manage your workflow. Please add the start and end dates to continue."}
        </p>
      </div>
    </Modal>
  );
};

export default PlaningNotSaveWarning;
